module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAACfSURBVDhPxZO9DcIwEEYdpqBMGTrKjEBJR4nYhA0YgZFo08EG0FHCO92HLA5HsggST3r67FN8kn/SPCBNYKb8mkKDGy6wCe6wgG0hs0IrjTnHA2asKk4YF5RsMWMVscT48Zh7dGwGZw1r7dDRIV48qhmUv7vG1qOaTvnWoPdhFRsl6Cxg8jUa1mSNcdHLI94xY9XAFUtvYouf/PtvTOkJy7iJhl4J0IUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/upper_bound-node.png
// module id = 1003
// module chunks = 0